module.exports = __webpack_public_path__ + "static/img/case9.92fe3b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case9.jpg
// module id = coMM
// module chunks = 0